<template>
  <div :class="$style.wrapper">
    <header :class="$style.header">
      <div>
        <p :class="$style.headerLabel">Документация</p>
        <h1>Политика обработки персональных данных</h1>
      </div>
    </header>

    <article :class="$style.article">
      <section :class="$style.section">
        <p><strong>Индивидуальный предприниматель СУКАЧ ОЛЕГ ЮВЕНАЛЬЕВИЧ</strong></p>
        <p>
          В соответствии с ч. 4 ст. 22 Федерального закона от 27.07.2006 №152-ФЗ «О персональных данных» сведения, содержащиеся в реестре операторов, за исключением сведений о средствах обеспечения безопасности персональных данных при их обработке, являются общедоступными
        </p>
      </section>

      <section :class="$style.section">
        <h2>Регистрационный номер</h2>
        <p>77-25-522908</p>
      </section>

      <section :class="$style.section">
        <h2>Дата и основание внесения оператора в реестр</h2>
        <p>Приказ № 838 от 17.12.2025</p>
      </section>

      <section :class="$style.section">
        <h2>Наименование оператора</h2>
        <p>Индивидуальный предприниматель СУКАЧ ОЛЕГ ЮВЕНАЛЬЕВИЧ</p>
      </section>

      <section :class="$style.section">
        <h2>ИНН</h2>
        <p>772382636138</p>
      </section>

      <section :class="$style.section">
        <h2>Юридический адрес</h2>
        <p>г. Москва</p>
      </section>

      <section :class="$style.section">
        <h2>Дата регистрации уведомления</h2>
        <p>16.12.2025</p>
      </section>

      <section :class="$style.section">
        <h2>Субъекты РФ, на территории которых происходит обработка персональных данных</h2>
        <p>Российская Федерация</p>
      </section>

      <section :class="$style.section">
        <h2>Наличие шифровальных средств</h2>
        <p>Не используется</p>
      </section>

      <section :class="$style.section">
        <h2>Трансграничная передача</h2>
        <p>Нет</p>
      </section>

      <section :class="$style.section">
        <h2>Сведения о местонахождении БД (страны)</h2>
        <p>Россия</p>
      </section>

      <section :class="$style.section">
        <h2>Описание мер, предусмотренных ст. 18.1 и 19 Закона</h2>
        <p>
          Разработаны локальные акты, по вопросам обработки персональных данных. Лица, непосредственно осуществляющие обработку персональных данных, ознакомлены с положениями законодательства Российской Федерации о персональных данных, в том числе с требованиями по защите персональных данных, документами, определяющими политику в отношении обработки персональных данных, локальными актами по вопросам обработки персональных данных. Назначен ответственный за организацию обработки персональных данных. На стенде (и (или) сайте) размещен документ, определяющий политику в отношении обработки персональных данных, и сведения о реализуемых требованиях к защите персональных, данных. Разработаны модели угроз безопасности персональным данным в информационных системах. В информационных системах установлен 3 уровень защищенности персональных данных. Обеспечивается учет машинных носителей персональных данных. Обеспечивается восстановление персональных данных, модифицированных или уничтоженных вследствие несанкционированного доступа к ним. Разработаны правила доступа к персональным данным, обрабатываемым в информационной системе персональных данных, а также обеспечивается регистрация и учет всех действий, совершаемых с персональными данными в информационной системе персональных данных. Осуществляется внутренний контроль соответствия обработки персональных данных требованиям Федерального закона РФ № 152 «О персональных данных» и принятым в соответствии с ним нормативно правовым актам. Исключена возможность неконтролируемого проникновения или пребывания посторонних лиц в помещения, где ведется работа с персональными данными. Обеспечена сохранность носителей персональных данных и средств защиты информации. Для обеспечения безопасности персональных данных применяются программно-технические средства, прошедшие в установленном порядке процедуру оценки соответствия.
        </p>
      </section>

      <section :class="$style.section">
        <h2>Дата начала обработки персональных данных</h2>
        <p>02.10.2025</p>
      </section>

      <section :class="$style.section">
        <h2>Срок или условие прекращения обработки персональных данных</h2>
        <p>Прекращение статуса индивидуального предпринимателя</p>
      </section>

      <section :class="$style.section">
        <h2>Дата и основание внесения записи в реестр</h2>
        <p>Приказ № 838 от 17.12.2025</p>
      </section>

      <section :class="$style.section">
        <h2>Цели обработки персональных данных</h2>

        <div :class="$style.goalBlock">
          <h3>№1</h3>

          <div :class="$style.goalItem">
            <strong>цель обработки персональных данных</strong>
            <p>Подготовка, заключение и исполнение гражданско-правового договора</p>
          </div>

          <div :class="$style.goalItem">
            <strong>категории персональных данных</strong>
            <p>фамилия, имя, отчество, год рождения, месяц рождения, дата рождения, место рождения, социальное положение, адрес электронной почты, адрес места жительства, адрес регистрации, номер телефона, СНИЛС, ИНН, данные документа, удостоверяющего личность, реквизиты банковской карты, номер расчетного счета, номер лицевого счета;</p>
          </div>

          <div :class="$style.goalItem">
            <strong>категории субъектов, персональные данные которых обрабатываются</strong>
            <p>Контрагенты, Представители контрагентов, Клиенты, Посетители сайта, Законные представители;</p>
          </div>

          <div :class="$style.goalItem">
            <strong>правовое основание обработки персональных данных</strong>
            <p>
              обработка персональных данных осуществляется с согласия субъекта персональных данных на обработку его персональных данных, обработка персональных данных необходима для исполнения договора, стороной которого либо выгодоприобретателем или поручителем по которому является субъект персональных данных, а также для заключения договора по инициативе субъекта персональных данных или договора, по которому субъект персональных данных будет являться выгодоприобретателем или поручителем. Заключаемый с субъектом персональных данных договор не может содержать положения, ограничивающие права и свободы субъекта персональных данных, устанавливающие случаи обработки персональных данных несовершеннолетних, если иное не предусмотрено законодательством Российской Федерации, а также положения, допускающие в качестве условия заключения договора бездействие субъекта персональных данных;
            </p>
          </div>

          <div :class="$style.goalItem">
            <strong>перечень действий с персональными данными</strong>
            <p>распространение, Сбор, Запись, Систематизация, Накопление, Хранение, Уточнение (обновление, изменение), Извлечение, Использование, Передача (предоставление, доступ), Обезличивание, Блокирование, Удаление, Уничтожение;</p>
          </div>

          <div :class="$style.goalItem">
            <strong>обработка персональных данных</strong>
            <p>смешанная, с передачей по внутренней сети юридического лица, с передачей по сети Интернет</p>
          </div>
        </div>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  name: "DocsPersonalData",
  mounted() {
    // Скрываем MainButton при переходе на эту страницу
    const tg = window.Telegram?.WebApp
    const mb = tg?.MainButton
    if (mb) {
      mb.hide()
    }
  },
}
</script>

<style lang="scss" module>
.wrapper {
  padding: 1.25rem 1rem 6rem 1rem;
}

.header {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 1rem;
}

.headerLabel {
  font-size: 0.75rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9b9ba1;
  margin: 0 0 0.15rem 0;
}

.header h1 {
  font-size: 1.3rem;
  line-height: 1.25;
  margin: 0;
}

.article {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.section {
  border: 1px solid #ebeaea;
  border-radius: 0.75rem;
  padding: 1rem;
  background: #fff;
}

.section h2 {
  margin: 0 0 0.5rem 0;
  font-size: 1.05rem;
}

.section h3 {
  margin: 0 0 1rem 0;
  font-size: 0.95rem;
  font-weight: 600;
}

.section p {
  margin: 0 0 0.5rem 0;
  line-height: 1.45;
  color: #2c2d30;
}

.section p:last-child {
  margin-bottom: 0;
}

.section strong {
  font-weight: 600;
  color: #2c2d30;
}

.goalBlock {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.goalItem {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.goalItem strong {
  font-size: 0.9rem;
  text-transform: lowercase;
  font-weight: 600;
}

.goalItem p {
  margin: 0;
  line-height: 1.5;
}
</style>
